import {Navigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import Auth from '../../auth';

export default function LogoutRequired({children}) {
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    let mounted = true;

    Auth.isLoggedIn().then(isLoggedIn => {
      if (mounted)
        setLoggedIn(isLoggedIn);
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (loggedIn === null)
    return null;

  if (loggedIn)
    return <Navigate to="/login" replace />;

  return children;
}